import styled from "styled-components";

export const IconLetter = styled.div`
  border: none;
  border-radius: 50%;
`;
